import * as routeActions from 'react-router-redux';

const dispatchLocation = store => next => action => {
    const { routeType, ...location } = action;
    if (!routeType) {
        return next(action);
    }
    store.dispatch(routeActions[action.routeType](location));
};

export default dispatchLocation;



// WEBPACK FOOTER //
// ./src/dispatch_location.js